module.exports = __webpack_public_path__ + "static/media/play_white.998959b0.svg";